import { render, staticRenderFns } from "./chatWelcome.vue?vue&type=template&id=526f532e&scoped=true"
import script from "./chatWelcome.vue?vue&type=script&lang=js"
export * from "./chatWelcome.vue?vue&type=script&lang=js"
import style0 from "@/assets/css/chat_css/chatWelcome.css?vue&type=style&index=0&id=526f532e&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "526f532e",
  null
  
)

export default component.exports